import { ResponsiveSize } from './types';

export const SortedResponsiveSizes: ResponsiveSize[] = ['s', 'm', 'l', 'xl', 'xxl'];

export const isSizeInList = (size: ResponsiveSize, list: ResponsiveSize[]) => list.includes(size);

export const isSizeLargerThan = (size: ResponsiveSize, reference: ResponsiveSize) => SortedResponsiveSizes.indexOf(size) > SortedResponsiveSizes.indexOf(reference);

export const isSizeSmallerThan = (size: ResponsiveSize, reference: ResponsiveSize) => SortedResponsiveSizes.indexOf(size) < SortedResponsiveSizes.indexOf(reference);
